export type RdsEnvironmentConfig = {
  environment_id?: number;
  resource_id?: number;
  enabled?: boolean;
  rds_instance_type?: string;
  rds_selfhosted?: string;
};

export type RdsServiceConfig = {
  name: string;
  extra_data: {
    postgres_version: string;
  };
  environment_options?: RdsEnvironmentConfig[];
};

export const rdsInstanceTypes = [
  "db.t3.micro",
  "db.t3.small",
  "db.t3.medium",
  "db.t3.large",
  "db.t3.xlarge",
  "db.t3.2xlarge",
  "db.m6g.large",
  "db.m6g.xlarge",
  "db.m6g.2xlarge",
  "db.m6g.4xlarge",
  "db.m6g.8xlarge",
  "db.m6g.12xlarge",
  "db.m6g.16xlarge",
];

export const postgresVersions = ["9.6", "10", "11", "12", "13"];
